module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'pp-content': 1,
      'pp-content--fullscreen': _vm.empty
    }
  }, [_c('div', {
    class: {
      'pp-search': 1,
      'pp-search--zerostate': _vm.empty
    }
  }, [_c('div', {
    staticClass: "pp-search-bar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.term),
      expression: "term"
    }],
    ref: "mobileSearch",
    staticClass: "pp-search-bar__input",
    attrs: {
      "type": "search",
      "placeholder": "Search"
    },
    domProps: {
      "value": (_vm.term)
    },
    on: {
      "keydown": _vm.onKeyDown,
      "focus": _vm.onFocus,
      "blur": _vm.onBlur,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.term = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.empty && !_vm.hideEmptystate) ? _c('div', {
    staticClass: "pp-search__icon"
  }, [_c('img', {
    attrs: {
      "src": "/assets/images/search_icon.png"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.empty && _vm.term && !_vm.hideEmptystate) ? _c('div', {
    staticClass: "pp-search__content"
  }, [_vm._v("\n            We can't find anything for those search terms.\n        ")]) : _vm._e(), _vm._v(" "), (_vm.empty && !_vm.term && !_vm.hideEmptystate) ? _c('div', {
    staticClass: "pp-search__content"
  }, [_vm._v("\n            Search for albums or tracks by title, composer, ensemble, artist, or code\n        ")]) : _vm._e(), _vm._v(" "), (!_vm.empty) ? _c('div', {
    staticClass: "pp-search__results"
  }, [_c('div', {
    staticClass: "pp-section"
  }, [_c('div', {
    staticClass: "pp-section__header"
  }, [_vm._v("\n                    Composer search results for '" + _vm._s(_vm.term) + "'\n                ")]), _vm._v(" "), (_vm.composers.length > 0) ? _c('artist-grid', {
    attrs: {
      "link-to": "/browse/composers/{id}",
      "items": _vm.composers,
      "reached-end": _vm.reachedEnd,
      "paginating": _vm.paginating,
      "can-paginate": true
    },
    on: {
      "paginate": _vm.loadMore
    }
  }) : _vm._e()], 1)]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6945bc6d","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/routes/SearchComposers.vue
// module id = 133
// module chunks = 0 1